/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ConnectionSiteView } from './connectionSiteView';

export interface ExternalConnectionView { 
    id?: string;
    provider?: ExternalConnectionView.ProviderEnum;
    status?: ExternalConnectionView.StatusEnum;
    tenantId?: string;
    tenantDomain?: string;
    errorMessage?: string;
    createdByUserId?: number;
    connectedAt?: Date;
    sites?: Array<ConnectionSiteView>;
}
export namespace ExternalConnectionView {
    export type ProviderEnum = 'SHAREPOINT';
    export const ProviderEnum = {
        SHAREPOINT: 'SHAREPOINT' as ProviderEnum
    };
    export type StatusEnum = 'PENDING_CONSENT' | 'ACTIVE' | 'ERROR' | 'REVOKED';
    export const StatusEnum = {
        PENDINGCONSENT: 'PENDING_CONSENT' as StatusEnum,
        ACTIVE: 'ACTIVE' as StatusEnum,
        ERROR: 'ERROR' as StatusEnum,
        REVOKED: 'REVOKED' as StatusEnum
    };
}